import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import { environment } from './utils'

export const SentryInit = (app: App) => {
    /* istanbul ignore next */
    if (import.meta.env.VUE_APP_SENTRY_DSN) {
        Sentry.init({
            app,
            dsn: import.meta.env.VUE_APP_SENTRY_DSN,
            release: `study@${import.meta.env.VUE_APP_VERSION}`,
            environment,
            integrations: [
                Sentry.replayIntegration({
                    networkDetailAllowUrls: [ new RegExp('.*') ],
                }),
            ],
            replaysSessionSampleRate: 0.001,
            replaysOnErrorSampleRate: 0.001,
            beforeSend: (event, hint) => {
                const originalException = hint?.originalException as Error | string
                const stacktraceFilename = event.exception?.values?.[0]?.stacktrace?.frames?.[0].filename
                if (
                    originalException
                    && (
                        originalException.toString().includes('Invalid session token')
                        || originalException.toString().includes('Unable to connect to the Parse API')
                        || originalException.toString().includes('Unable to authenticate')
                        || originalException.toString().includes('window.webkit.messageHandlers')
                        || originalException.toString().includes('ceCurrentVideo.currentTime')
                        || originalException.toString().includes('instantSearchSDKJSBridgeClearHighlight')
                        || originalException.toString().includes('NotReadableError: The I/O read operation failed')
                        || originalException.toString().includes('Can\'t find variable: gmo')
                        // These network errors typically seem to be from non-pocketprep requests
                        || originalException.toString().includes('Network Error')
                        || originalException.toString().includes('Failed to fetch')
                        || originalException.toString().includes('Request timeout after 10000 milliseconds')
                        || originalException.toString().includes('timeout exceeded')
                        || originalException.toString().includes('Load failed')
                        || originalException.toString().includes('NetworkError when attempting to fetch resource.')
                        || originalException.toString().includes('Request aborted')
                        || originalException.toString().includes('AbortError')
                        || originalException.toString().includes('Database deleted by request of the user')
                        // This prevents errors generated outside of our code (e.g from Chrome's translate extension)
                        || (
                            originalException.toString().includes('Maximum call stack size exceeded')
                            && stacktraceFilename === 'undefined'
                        )
                        || originalException.toString().includes('Non-Error promise rejection captured with value')
                        || originalException.toString()
                            .includes('(type=unhandledrejection) captured as promise rejection')
                    )
                ) {
                    return null
                }

                return event
            },
        })
    }
}
